import {
  Box,
  Typography,
  Button,
  Modal,
  Card,
  CircularProgress,
} from "@mui/material";

import { colors } from "../../values/colors";
import { useGetAllRolesQuery } from "../../services/auctionAPI";
import PlayerAuctionCard from "../PlayerAuctionCard";

const PassPlayerModal = ({
  open,
  onClose,
  player,
  onConfirm,
  profile,
  isJitoTournament,
  isLoading,
  playerNumber,
}) => {
  const { data: rolesData } = useGetAllRolesQuery();
  const roles = rolesData?.data || [];

  const roleName = roles?.find(
    (r) => r?._id === player?.playerId?.roleId
  )?.name;



  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card
        sx={{
          width: 1100,
          p: 3,
          borderRadius: "16px",
          boxShadow: "0px 4px 25px rgba(0,0,0,0.15)",
        }}
      >
        <Typography
          variant="h6"
          sx={{ mb: 3, fontWeight: 600, fontSize: "1.6rem" }}
        >
          Are you sure you want to pass this player:
        </Typography>

        {/* Main Grid: LEFT IMAGE + RIGHT DETAILS */}
        <PlayerAuctionCard
          player={player}
          playerNumber={playerNumber}
          roleName={roleName}
          isJitoTournament={isJitoTournament}
          showVisibilityIcon={false}
        />

        {/* Footer Buttons */}
        <Box
          sx={{
            mt: 3,
            display: "flex",
            justifyContent: "center",
            gap: 3,
          }}
        >
          <Button
            variant="contained"
            onClick={onClose}
            sx={{
              backgroundColor: "#1E1E1E",
              color: "#fff",
              textTransform: "none",
              borderRadius: "32px",
              px: 6,
              py: 1.2,
              fontSize: "1.5rem",
              "&:hover": { backgroundColor: "#000" },
            }}
          >
            No
          </Button>

          <Button
            variant="contained"
            onClick={onConfirm}
            sx={{
              background: colors.linearGradent,
              color: "#fff",
              textTransform: "none",
              borderRadius: "32px",
              px: 6,
              py: 1.2,
              fontSize: "1.5rem",
            }}
          >
            {isLoading ? (
              <CircularProgress size={26} sx={{ color: "#fff" }} />
            ) : (
              "Yes"
            )}
          </Button>
        </Box>
      </Card>
    </Modal>
  );
};

export default PassPlayerModal;
